import '../../css/misc/timeline.css';

import React, { Component } from 'react';
import { Col, Row, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { abbreviate } from '../utils/utils';
import SignalRService from "../../controllers/SignalRService";
import Moment from 'react-moment';
import ChatsService from '../../controllers/ChatController';
import { search, sort, selectHistoryIntercation, setSearchText } from '../../redux/interactionsSlice';
import InteractionMessagesModal from './interactionmessagesmodal';
import ConversationSummary from '../chat/conversationsummary';
import InteractionMailModal from '../misc/interactionMailModal';
import Mailhistory from './mailhistory';
import { changeJanusStatus } from 'src/redux/parametersSlice';
import BlockUi from 'react-block-ui';

// function waitForRegisterTimeline() {
//     return new Promise((resolve) => {
//         SignalRService.registerOmniChannelInteractionsList(e => {
//             resolve(e);
//         });
//     });
// }

// async function requestData(params) {
//     let ret = [];
//     try {
//         //const registerPromise = waitForRegisterTimeline();

//         //ret = await registerPromise;
//     } catch (error) {
//         ret = [];
//     }
//     return ret;
// }

function removeDuplicates(existing, newData) {

    let existingIds = new Set(existing.map(x => x.id));

    newData.forEach(v => {
        if (v.id !== null && !existingIds.has(v.id)) {
            v.startDate = new Date(v.startDate);
            existing.push(v);
            existingIds.add(v.id);
        }
    });

    return existing;
}


class Timeline extends Component {

    constructor(props) {

        super(props)

        this.state = {
            search: "",
            loading: false,
            id: null,
            caller: "",
            channel: "",
            startDate: new Date(),
            endDate: new Date(),
            interactions: [],
            interaction: null,
            showInteraction: false,
            timeoutId: null,
            guid: null,
            showSummary: false,
            showInteractionMail: false,
            emailMessageNumber: null,
            iframeUrl: '',
            searchResult: [],
            outbound: false,
            showHistory: false,
            mail: null
        };

        this.toggleInteraction = this.toggleInteraction.bind(this);
        this.interactionClick = this.interactionClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchInteractons = this.searchInteractons.bind(this);
        this.toggleSummary = this.toggleSummary.bind(this);
        this.showSummary = this.showSummary.bind(this);
        this.toggleInteractionMail = this.toggleInteractionMail.bind(this);
        this.toggleHistory = this.toggleHistory.bind(this);
        this.makeCall = this.makeCall.bind(this);
        this.processResult = this.processResult.bind(this);

    }

    componentDidMount() {
        SignalRService.registerOmniChannelInteractionsList(this.processResult);
        this.searchInteractons();
    }

    processResult(result) {
        let interactions = [];

        interactions = removeDuplicates(interactions, result);


        interactions.sort(function (a, b) {
            return new Date(b.startDate) - new Date(a.startDate);
        });

        this.setState({
            interactions: interactions,
            searchResult: interactions
        });
        this.setState({
            loading: false
        });
    }
    componentWillUnmount() {
        this.props.setSearchText("");
    }

    searchInteractons = async () => {

        if (this.props.interaction) {

            let from = this.props.interaction.from;
            let phone = this.props.interaction.phone;

            let data = {
                "extension": this.props.extension,
                "userId": this.props.userId,
                "filterByUser": false,
                "search": this.state.search,
                "bookId": null,
                "froms": []
            }

            if (from === phone && from.length > 9)
                from = from.substr(from.length - 9);

            data.froms.push({ "type": "from", "value": from });

            if (phone) {
                let ninePhone = phone.substr(phone.length - 9);
                data.froms.push({ "type": "phone", "value": ninePhone });
            }

            if (from.indexOf("@") > -1)
                data.froms.push({ "type": "email", "value": from });

            if (this.props.interaction.phone != null && this.props.interaction.phone.trim() !== "" && this.props.interaction.from !== this.props.interaction.phone) {

                if (phone.length > 9)
                    phone = phone.substr(phone.length - 9);

                let exists = data.froms.find(x => x.value === phone);
                if (!exists)
                    data.froms.push({ "type": "phone", "value": phone });
            }

            if (this.props.interaction.email && this.props.interaction.email !== this.props.interaction.from) {
                let exists = data.froms.find(x => x.value === this.props.interaction.email);
                if (!exists)
                    data.froms.push({ "type": "email", "value": this.props.interaction.email });
            }

            if (this.props.interaction.bookId) {
                data.bookId = parseInt(this.props.interaction.bookId);
            }

            if (this.props.interaction.contacts && this.props.interaction.contacts.length === 1) {

                let contact = this.props.interaction.contacts[0];

                let exists = data.froms.find(x => x.value === contact.mail);

                if (!exists)
                    data.froms.push({ "type": "email", "value": contact.mail });

                if (contact.phone && contact.phone.trim() !== "" && phone !== contact.phone) {

                    let cntPhone = contact.phone;

                    if (cntPhone.length > 9)
                        cntPhone = cntPhone.substr(from.length - 9);
                    let exists = data.froms.find(x => x.value === cntPhone);

                    if (!exists)
                        data.froms.push({ "type": "phone", "value": cntPhone });

                }
            }

            this.setState({
                loading: true
            });

            SignalRService.getOmniChannelInteractions(data);

        }
    }

    interactionMailClick = (emailMessageNumber, inbox) => {
        var data = JSON.parse(localStorage.getItem("fc-logged"));
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_faagtinbox=1`

        this.setState({ emailMessageNumber: emailMessageNumber });
        this.setState({ iframeUrl: url });
        this.toggleInteractionMail();
    }

    interactionClick = (data) => {
        if (data.emailMessageNumber) {
            console.log(data);
            var ls = JSON.parse(localStorage.getItem("fc-logged"));
            var rcu = localStorage.getItem("faRCUser");
            var rcp = localStorage.getItem("faRCPwd");
            var roundcubeUrl = localStorage.getItem("faRC");

            var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${ls.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${data.emailMessageNumber}&_mbox=${data.emailInbox}&_faagtinbox=1`

            this.setState({ emailMessageNumber: data.emailMessageNumber, iframeUrl: url, interaction: data });
            this.toggleInteractionMail();
        } else {
            ChatsService.getChat(data.chatGuid, res => {
                this.setState({
                    interaction: res.data
                });
                this.toggleInteraction();
            });
        }
    }

    toggleInteractionMail = e => {
        console.log("interactionMailClick");
        this.setState({ showInteractionMail: !this.state.showInteractionMail });

    }

    toggleInteraction = e => {
        this.setState({ showInteraction: !this.state.showInteraction });
    }

    handleChange = e => {

        this.setState({ search: e.target.value });

        if (e.target.value !== null && e.target.value.trim()) {

            clearTimeout(this.state.timeoutId);

            let timeoutId = setTimeout(z => {
                this.props.setSearchText(e.target.value);

                let searchResult = this.state.interactions.filter(x =>
                    (x.groupName != null && x.groupName.toLowerCase().includes(e.target.value.toLowerCase()))
                    || (x.email != null && x.email.toLowerCase().includes(e.target.value.toLowerCase()))
                    || (x.emailSubject != null && x.emailSubject.toLowerCase().includes(e.target.value.toLowerCase()))
                    || (x.phone != null && x.phone.toLowerCase().includes(e.target.value.toLowerCase()))
                    || (x.userName != null && x.userName.toLowerCase().includes(e.target.value.toLowerCase()))
                );
                this.setState({
                    searchResult: searchResult
                });
            }, 500);

            this.setState({
                timeoutId: timeoutId,
                search: e.target.value,
            });

        } else {
            this.setState({
                searchResult: this.state.interactions
            });
        }

    }

    toggleSummary = data => {
        if (data) {

            this.setState({
                guid: data.chatGuid,
                id: data.id,
                channel: data.channel,
                outbound: data.outbound
            });

            setTimeout(() => {
                this.showSummary();
            }, 50);
        }

    }

    showSummary = () => {
        this.setState({
            showSummary: !this.state.showSummary
        });
    }

    toggleHistory = data => {
        this.setState({ showHistory: !this.state.showHistory, mail: data });
    }

    makeCall = (e) => {
        e.preventDefault();
        this.props.changeJanusStatus("makeCall");
        SignalRService.makeCall({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "called": this.props.interaction.phone
        });
    }

    render() {
        return (<>
            <Row>
                <Col>
                    <div className="card" style={{ width: "99%", height: "100px" }}>
                        <div className="card-body">
                            <div className="d-flex flex-wrap flex-sm-nowrap">
                                <div className="me-7 mb-4">
                                    <div className="symbol symbol-80px symbol-fixed position-relative">
                                        <div className='timeline-name'>{abbreviate(this.props.interaction.name)}</div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">

                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">

                                        <div className="d-flex flex-column">

                                            <div className="d-flex align-items-center mb-2">
                                                <div className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{this.props.interaction.name}</div>
                                            </div>
                                            <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2" style={{ position: "relative", bottom: "5px" }}>
                                                <div className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                                                    <FontAwesomeIcon icon={solid('phone')} className='me-1' /><span><a className={""} href="/#" onClick={this.makeCall}>{this.props.interaction.phone}</a></span>
                                                </div>
                                                <div className="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                                                    <FontAwesomeIcon icon={duotone('envelope')} className='me-1' /><span><a className={""} href={`mailto:${this.props.interaction.email}`}>{this.props.interaction.email}</a></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='card' style={{ width: "99%", height: "100%" }}>

                        <div className='card-header align-items-center border-0 mt-4'>
                            <h3 className="card-title align-items-start flex-column">
                                <span className="fw-bold mb-2 text-dark">{this.props.t("timeline")}</span>
                                <span className="text-muted fw-semibold fs-7">{this.state.searchResult.length} {this.props.t("interactions")}</span>
                                <Row className='searchconversations'>
                                    <Col>
                                        <FontAwesomeIcon className='searchicon' icon={solid("magnifying-glass")} />
                                        <Form.Control className='searchinput' type="text" placeholder={this.props.t("search")} onChange={this.handleChange}></Form.Control>
                                    </Col>
                                </Row>
                            </h3>
                        </div>
                        <div className="card-body pt-5 ps-15" style={{ "height": "385px", "overflow": "auto" }}>
                            {
                                !this.state.loading &&
                                <div className="timeline-label">
                                    {
                                        this.state.searchResult.map(x => {
                                            return (
                                                <div key={x.id} className="timeline-item mb-10 mt-n1" >
                                                    <div className="timeline-icon symbol symbol-circle symbol-40px me-4">
                                                        <div className={`icon ${x.channel.toLowerCase()}`} ></div>
                                                    </div>
                                                    <div className="timeline-content mb-6" >
                                                        <Row>
                                                            <Col md={1}>
                                                                <div className={`${!x.outbound ? 'text-success' : 'text-primary'} text-center`}  >
                                                                    {
                                                                        (x.outbound) &&
                                                                        <FontAwesomeIcon className='primary' size='2x' icon={duotone('arrow-up-right')} />
                                                                    }
                                                                    {
                                                                        (!x.outbound) &&
                                                                        <FontAwesomeIcon className='success' size='2x' icon={duotone('arrow-down-left')} />
                                                                    }
                                                                </div>
                                                            </Col>
                                                            <Col md={3}>
                                                                <div className="fs-5 fw-semibold mb-2 text-primary">{x.groupName}</div>
                                                                <div className="fs-5 fw-semibold mb-2 text-primary">{x.userName}</div>
                                                            </Col>
                                                            <Col md={3}>
                                                                <OverlayTrigger
                                                                    placement="left"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                                                        {x.phone}
                                                                    </Tooltip>}>
                                                                    <div className="d-flex align-items-center mt-1 fs-6">
                                                                        <div className="text-muted me-2 fs-5 hide-text">{x.phone}</div>
                                                                    </div>
                                                                </OverlayTrigger>
                                                                <OverlayTrigger
                                                                    placement="left"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                                                        {x.email}
                                                                    </Tooltip>}>
                                                                    <div className="d-flex align-items-center mt-1 fs-6">
                                                                        <div className="text-muted me-2 fs-5 hide-text">{x.email}</div>
                                                                    </div>
                                                                </OverlayTrigger>
                                                                <div className="d-flex align-items-center mt-1 fs-6 hide-text">
                                                                    <div className="text-muted me-2 fs-5"><Moment format='DD/MM/yyyy HH:mm'>{x.startDate}</Moment></div>
                                                                </div>
                                                            </Col>
                                                            <Col md={2}>
                                                                <OverlayTrigger
                                                                    placement="left"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                                                        {x.emailSubject}
                                                                    </Tooltip>}>
                                                                    <div className="d-flex align-items-center mt-1 fs-6">
                                                                        <div className="text-muted me-2 fs-5 hide-text">{x.emailSubject}</div>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </Col>
                                                            <Col md={1}>

                                                                {
                                                                    x.channel.toLowerCase() !== "call" &&
                                                                    <OverlayTrigger
                                                                        placement="left"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={<Tooltip style={{ position: "fixed" }}>
                                                                            {this.props.t("viewContent")}
                                                                        </Tooltip>}>
                                                                        <Button variant="light-primary" onClick={e => { this.interactionClick(x); }}><FontAwesomeIcon icon={duotone("eye")} /></Button>
                                                                    </OverlayTrigger>
                                                                }
                                                            </Col>
                                                            <Col md={1}>
                                                                {
                                                                    this.props.aiEnabled && x.channel.toLowerCase() !== "call" &&
                                                                    <OverlayTrigger
                                                                        placement="left"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={<Tooltip style={{ position: "fixed" }}>
                                                                            {this.props.t("aisummary")}
                                                                        </Tooltip>}>
                                                                        <Button variant="light-primary" onClick={e => { this.toggleSummary(x); }}  ><FontAwesomeIcon icon={duotone("square-list")} /></Button>
                                                                    </OverlayTrigger>
                                                                }
                                                            </Col>
                                                            <Col md={1}>
                                                                {
                                                                    x.channel.toLowerCase() === "mail" &&
                                                                    <OverlayTrigger
                                                                        placement="left"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={<Tooltip style={{ position: "fixed" }}>
                                                                            {this.props.t("emailthread")}
                                                                        </Tooltip>}>
                                                                        <Button variant="light-primary" onClick={e => { this.toggleHistory(x); }}  ><FontAwesomeIcon icon={duotone("clock-rotate-left")} /></Button>
                                                                    </OverlayTrigger>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>)
                                        })
                                    }
                                </div>
                            }

                            {
                                this.state.loading &&
                                <div className='d-flex flex-column flex-center' style={{ position: "relative" }}>
                                    <div className="fs-1 text-center">{this.props.t("interactions")}</div>
                                    <div className="fs-4 text-muted text-center">{this.props.t("loading")}</div>
                                    <div className='nochatsimg'></div>
                                </div>
                            }
                        </div>
                    </div>
                </Col>
            </Row>

            <InteractionMailModal show={this.state.showInteractionMail} toggleModal={this.toggleInteractionMail} interaction={this.state.interaction} url={this.state.iframeUrl}></InteractionMailModal>
            <InteractionMessagesModal show={this.state.showInteraction} toggleModal={this.toggleInteraction} interaction={this.state.interaction}></InteractionMessagesModal>
            <ConversationSummary show={this.state.showSummary} toggleModal={this.toggleSummary} guid={this.state.guid != null ? this.state.guid : -1} id={this.state.id} channel={this.state.channel} outbound={this.state.outbound}></ConversationSummary>
            <Mailhistory show={this.state.showHistory} toggleModal={this.toggleHistory} mail={this.state.mail}></Mailhistory>

        </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        aiEnabled: state.parameters.aiEnabled
    };
};

export default compose(connect(mapStateToProps, { search, sort, selectHistoryIntercation, setSearchText, changeJanusStatus }), withTranslation())(Timeline);